import React from 'react';
import { Car } from 'lucide-react';

const Header = ({ onContactClick }) => {
  return (
    <header className="bg-black text-white">
      <div className="max-w-5xl mx-auto px-4 py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Car className="h-6 w-6 mr-2" />
            <span className="text-xl font-bold">MOT Check Service</span>
          </div>
          {onContactClick && (
            <button 
              onClick={onContactClick}
              className="text-white hover:underline"
            >
              Contact
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
